import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, KeyRound } from 'lucide-react';
import { useLanguage } from '../../assets/js/LanguageContext';
import SectionEyebrow from '../common/SectionEyebrow';
import IconTile from '../common/IconTile';
import Footer from '../Footer';
import '../../assets/styles/Login.css';
import '../../assets/styles/SectionBand.css';
import '../../assets/styles/FormCard.css';
import '../../assets/styles/PinPage.css';

const Pin = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [pin, setPin] = useState('');
  const [errorKey, setErrorKey] = useState('');
  const [checking, setChecking] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const code = pin.replace(/\s+/g, '');
    if (!code || checking) return;

    setErrorKey('');
    setChecking(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/verifyPin`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pin: code })
      });
      const data = await response.json();

      if (data.valid && data.active) {
        localStorage.setItem('pin', code);
        navigate('/welcome');
        return;
      }
      setErrorKey(!data.valid ? 'pin_error_invalid' : data.full ? 'pin_error_full' : 'pin_error_closed');
    } catch (error) {
      setErrorKey('pin_error_server');
    }
    setChecking(false);
  };

  return (
    <div className="brand-page-stack pin-page">
      <section className="section-band">
        <div className="section-band__inner tp-pin">
          <div className="tp-pin__main">
            <h1 className="tp-sr-only">{t('home0_join_code')}</h1>
            <div aria-hidden="true">
              <SectionEyebrow>{t('home0_join_code')}</SectionEyebrow>
            </div>
            <p className="section-band__lead tp-pin__lead">{t('pin_lead')}</p>

            <form className="tp-form tp-pin__form" onSubmit={handleSubmit} noValidate>
              <div className="tp-field">
                <label htmlFor="pin-code">{t('pin_label')}</label>
                <input
                  id="pin-code"
                  type="text"
                  inputMode="numeric"
                  autoComplete="one-time-code"
                  className={`tp-pin__input ${errorKey ? 'has-error' : ''}`.trim()}
                  value={pin}
                  onChange={(event) => {
                    setPin(event.target.value);
                    if (errorKey) setErrorKey('');
                  }}
                  placeholder={t('pin_placeholder')}
                  aria-invalid={Boolean(errorKey)}
                  aria-describedby={errorKey ? 'pin-error' : 'pin-help'}
                  required
                />

                {errorKey && (
                  <p id="pin-error" className="tp-field__error" role="alert">{t(errorKey)}</p>
                )}
              </div>

              <button
                type="submit"
                className="btn btn--primary tp-form__submit"
                disabled={!pin.trim() || checking}
              >
                {t(checking ? 'pin_btn_loading' : 'pin_btn')}
                <ArrowRight size={16} strokeWidth={2.25} aria-hidden="true" />
              </button>

              <p id="pin-help" className="tp-form__footer">{t('pin_help')}</p>
            </form>
          </div>

          <div className="tp-pin__media">
            <IconTile accent="#7C3AED" icon={<KeyRound size="1em" strokeWidth={1.25} />} />
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Pin;
